export default {
  dateformat2 (oldVal) {
    if(oldVal){
      return oldVal.substring(4, 6) + '-' + oldVal.substring(6, 8);
    }
    return ''
  },
  // 涨幅
  dayincformat(oldVal){
    if(oldVal && oldVal!='--'){
      return Number.parseFloat(oldVal).toFixed(2)+'%'
    }
    return '--'
  },
  // 万份收益
  moneyvalueformat(oldVal){
    if(oldVal&&oldVal!='--'){
      return Number.parseFloat(oldVal).toFixed(4)
    }
    return '--'
  },
  // 七日年化收益率
  moneyvalueformat2(oldVal){
    if(oldVal&&oldVal!='--'){
      return Number.parseFloat(oldVal).toFixed(4)+'%'
    }
    return '--'
  },
  // 图片地址
  bankImg (alias) {
    if (alias == null || !alias) {
      return require(`../images/bank/defaultBank.png`)
    } else {
      return require(`../images/bank/${alias}.png`)
    }
  },
  // 银行卡名称
  bankInfo (bank) {
    let bankAcco = ''
    if (bank.bankAcco && bank.bankAcco.length > 4) {
      bankAcco = '[' + bank.bankAcco.substr(- 4, 4) + ']'
    }
    let capitalModeStr = bank.capitalModeStr ?  "-" + bank.capitalModeStr : "";
    return bank.bankName + bankAcco + capitalModeStr
  },
  // 银行卡限额
  bankLimit(bank, showMonth = false) {
    function trans(limit) {
      if (limit == -1) return '无限额';
      if (!limit || limit === '--' || isNaN(limit)) return "限额--";
      limit = parseInt(limit);
      return '限额' + (limit / 10000).toString() + "万";
    }
    var oncelimits = trans(bank.oncelimits);
    var daylimit = trans(bank.daylimit);
    let result = `单笔${oncelimits}，单日${daylimit}`
    if (showMonth && bank.monthlimit) {
      var monthlimit = trans(bank.monthlimit);
      result = `${result}，单月${monthlimit}`;
    }
    return result
  },
  formatMoney(value) {
    if (value != 0 && !value) return '';
    return this.$money.toMoney(value);
  },
  formatDate(value) {
    if (!value) return '';
    return value.replace(/(\d{4})[^\d]?(\d{2})[^\d]?(\d{2})/, '$1-$2-$3');
  }
}


// WEBPACK FOOTER //
// ./src/assets/filters/index.js